module.exports = __webpack_public_path__ + "media/images/black_history_month/okra-symbol-5554ef702e4d4148349457d8e06705f2.png";